// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1t5HT","link":"styles_link__1KpTK"};